<div class="modal" id="confirmModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
        <div [ngClass]="(currLang == 'ar') ? 'modal-content rtl '+modalType : 'modal-content '+modalType">
            <div class="modal-header">
                <div class="sub-header">
                    <h5 class="modal-title">{{'confirm-modal.confirm' | translate}}</h5>
                    <!-- <span *ngIf="modalType === 'activation'">{{userState ? 'confirm-modal.confirm-activating' : 'confirm-modal.confirm-deactivating'}}|translate
                        {{userName}}</span> -->
                    <span *ngIf="modalType === 'activation'">{{getModalHeader(userState)}}{{userName}}</span>
                    <ng-container *ngIf="modalType === 'regenerating'">
                        <span>Warning, this action will Regenerate the QR code for the
                            {{parents?.length}} selected users (issue new QR code).
                            This will deactivate any card printed earlier, and the new one will be the only one working
                            (th
                            know what is the last issued version please check the version number below the QR)
                        </span>
                        <span class="desc_ar">
                            تنبيه! اعادة اصدار الباركود سيقوم بالغاء جميع البطائق السابقة للاشخاص المختارين. في حال
                            الاستمرار في الطلب وحدها البطاقة الجديدة ستعمل، وسيتم رفض/الغاء البطائق السابقة من النظام
                            (يرجى
                            التاكد من رقم الاصدار تحت الباركود لمعرفة اخر نسخة فعالة من البطاقة)
                        </span>
                    </ng-container>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" [ngStyle]="{'text-align': currLang=='en' ? 'unset' : 'center' }">
                <div *ngIf="modalType != 'singleRegenerating'" class="password-container">
                    <span>{{'confirm-modal.enter-password'|translate}}</span>
                    <input type="text" [(ngModel)]="password">
                    <span class="error" *ngIf="passwordMismatch">{{passwordMismatch}}</span>
                </div>

                <ng-container *ngIf="modalType === 'singleRegenerating'">
                    <div class="confirm-single-regenerating">
                        <div class="msg">
                            {{'confirm-modal.confirm-single-regen-msg'|translate}}
                        </div>
                        <div class="user">
                            {{regenQrSingleUser.name}}
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="modal-footer">
                <button (click)="confirmFunction()"
                    [disabled]="modalType !== 'singleRegenerating' && (!password || password.length === 0)"
                    class="btn btn-primary" type="button">
                    {{'confirm-modal.confirm' | translate}}
                </button>
                <button (click)="cancelModalHandler()" type="button" class="btn btn-secondary"
                    data-dismiss="modal">{{'confirm-modal.cancel'|translate}}</button>
            </div>
        </div>
    </div>
</div>
<app-toaster-msg></app-toaster-msg>